import { render, staticRenderFns } from "./introheaderMobile.vue?vue&type=template&id=4ed2d4c0"
import script from "./introheaderMobile.vue?vue&type=script&lang=js"
export * from "./introheaderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports